import React from 'react'
import { TextField, MenuItem } from '@material-ui/core'
import { TextFieldProps } from '@material-ui/core/TextField'

import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  select: (props: { width: number }) => ({
    width: props.width
  }),
  menu: {}
}))

type SelectInputProps = {
  options: { value: any; label: string }[]
  selectHandler: (select: string) => void
  width?: number
  required?: boolean
} & TextFieldProps

const SelectInput: React.FC<SelectInputProps> = props => {
  const { value, label, selectHandler, options, width, fullWidth, required = false } = props
  const classes = useStyles({ width: width })
  return (
    <TextField
      className={classes.select}
      select
      label={label}
      value={value}
      onChange={(event: any) => selectHandler(String(event.target.value))}
      SelectProps={{
        MenuProps: {
          className: classes.menu
        }
      }}
      margin="normal"
      variant="outlined"
      fullWidth={fullWidth}
      required={required}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default SelectInput
